export default __webpack_public_path__ + "static/media/banner_bg_ipad_mini.20b82f76.svg";